// Data for CMO-level ERP-to-ERP Configurations (Add New CMO step 8 and Update CMO
// Details "ERP-to-ERP Configurations" sections). Product types, modules, messages,
// data elements, and Trigger Point seed data are all fetched live from the backend
// elsewhere (ErpToErpConfigurationSection.jsx) — only fixed UI enums with no seed-data
// concept (Field Type, Ingestion) and true fallback/default values remain here.

export const MODULE_OPTIONS = [
  { key: "forecastCollaboration", label: "Forecast Collaboration", disabled: true },
  { key: "purchaseOrders", label: "Purchase Orders", disabled: false },
  { key: "goodsReceipt", label: "Goods Receipt (current Batch Execution)", disabled: true },
  { key: "inventory", label: "Inventory", disabled: true },
  { key: "logisticsCollaboration", label: "Logistics Collaboration", disabled: false },
];

export const DEFAULT_PRODUCT_TYPES = [
  { productTypeID: 1, productTypeName: "Intermediate" },
  { productTypeID: 2, productTypeName: "API (Drug Substance)" },
  { productTypeID: 3, productTypeName: "Vial" },
  { productTypeID: 4, productTypeName: "Spray Dried Dispersions (SDD)" },
  { productTypeID: 5, productTypeName: "Bulk Drug Product (Bulk DP)" },
  { productTypeID: 6, productTypeName: "BNU" },
  { productTypeID: 7, productTypeName: "Finished Goods (FG)" },
];

export const DEFAULT_IDOC_FIELDS = [
  { field: "PO Number", isDefault: true, leadingZeros: "Yes", maxCharLength: "10" },
  { field: "Sponsor Product Code", isDefault: true, leadingZeros: "No", maxCharLength: "" },
  { field: "Sponsor Material Code", isDefault: true, leadingZeros: "No", maxCharLength: "" },
];

export const FIELD_TYPE_OPTIONS = ["Chain of Custody", "First Choice", "Second Choice"];

export const INGESTION_OPTIONS = ["Mandatory", "Not Mandatory", "Do not read"];

let nextId = 1;
export const genId = (prefix = "erp") => `${prefix}_${++nextId}`;

export const isShipmentModule = (moduleKey) => moduleKey === "logisticsCollaboration";
